import { LibraryComplexitiesMap } from './library-complexities-map.model'
import { LibraryComplexity } from './library-complexity.model'
import { LibraryEntry } from '../library-entry.model'
import { Type } from 'class-transformer'
import { User } from '@app/core/model/user.model'

export class LibraryComponentEntry extends LibraryEntry {
  id?: number
  name?: string
  versionNumber?: number
  language?: string
  createdTs?: Date
  @Type(() => User) createdBy?: User
  updatedTs?: Date
  @Type(() => User) updatedBy?: User
  fixedPricing: boolean
  fixedFeeEditable: boolean
  fixedFeeHasRoles: boolean
  libraryComponentTemplate?: { id: number; name: string }
  disciplineTypeName?: string
  componentComplexities?: LibraryComplexitiesMap
  complexities?: LibraryComplexity[]
}
